/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
// LandingPage route renders RentEventHomePage — its loader feeds the
// Featured kits section (2026-07-02). The template LandingPage duck is
// unused (the '/' route never pointed at it).
import { loadData as LandingPageLoader } from './RentEventHomePage/RentEventHomePage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as MakeOfferPageLoader } from './MakeOfferPage/MakeOfferPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as CalendarPickerPageLoader } from './CalendarPickerPage/CalendarPickerPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as RequestQuotePageLoader } from './RequestQuotePage/RequestQuotePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as ProviderDashboardPageLoader } from './ProviderDashboardPage/ProviderDashboardPage.duck';
import { loadData as RenterDashboardPageLoader } from './RenterDashboardPage/RenterDashboardPage.duck';
import { loadData as BookingsPageLoader } from './BookingsPage/BookingsPage.duck';
import { loadData as ProviderSignupPageLoader } from './ProviderSignupPage/ProviderSignupPage.duck';
import { loadData as WhatsHotPageLoader } from './WhatsHotPage/WhatsHotPage.duck';
import { loadData as StartRentalPageLoader } from './StartRentalPage/StartRentalPage.duck';
import { loadData as CompleteReturnPageLoader } from './CompleteReturnPage/CompleteReturnPage.duck';
import { loadData as ReportDamagePageLoader } from './ReportDamagePage/ReportDamagePage.duck';
import { loadData as ReportPickupIssuePageLoader } from './ReportPickupIssuePage/ReportPickupIssuePage.duck';
import { loadData as ReportIssuePageLoader } from './ReportIssuePage/ReportIssuePage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    MakeOfferPage: {
      loadData: MakeOfferPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    CalendarPickerPage: {
      loadData: CalendarPickerPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    RequestQuotePage: {
      loadData: RequestQuotePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    ProviderDashboardPage: {
      loadData: ProviderDashboardPageLoader,
    },
    RenterDashboardPage: {
      loadData: RenterDashboardPageLoader,
    },
    BookingsPage: {
      loadData: BookingsPageLoader,
    },
    ProviderSignupPage: {
      loadData: ProviderSignupPageLoader,
    },
    WhatsHotPage: {
      loadData: WhatsHotPageLoader,
    },
    StartRentalPage: {
      loadData: StartRentalPageLoader,
    },
    CompleteReturnPage: {
      loadData: CompleteReturnPageLoader,
    },
    ReportDamagePage: {
      loadData: ReportDamagePageLoader,
    },
    ReportPickupIssuePage: {
      loadData: ReportPickupIssuePageLoader,
    },
    ReportIssuePage: {
      loadData: ReportIssuePageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
